import { Box, BoxProps, Flex, FlexProps } from '@blockanalitica/ui';
import { ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router';
import styled, { css } from 'styled-components';
import Footer from './Footer';
import Header from './Header';

export interface BackgroundProps extends BoxProps {
  $bgFile?: string;
}

const ContentContainer = styled(Flex)<FlexProps>`
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  position: relative;
`;

const Background = styled(Box)<BackgroundProps>`
  position: absolute;
  top: 0;
  right: 0;
  width: 150vw;
  max-width: 1010px;
  height: 100%;
  z-index: -1;
  opacity: 0.6;

  background-repeat: no-repeat;
  background-size: contain;
  background-position: top right;

  ${(props) => css`
    ${props.$bgFile ? `background-image: url(${props.$bgFile});` : null}
  `}
`;

export default function Layout({ children }: { children?: ReactNode }) {
  const location = useLocation();

  let bgFile;
  if (location.pathname.startsWith('/spark-liquidity-layer')) {
    bgFile = '/assets/backgrounds/sll.svg';
  }
  if (location.pathname.startsWith('/savings')) {
    bgFile = '/assets/backgrounds/savings.svg';
  }
  if (location.pathname.startsWith('/spk')) {
    bgFile = '/assets/backgrounds/spk.svg';
  }
  if (location.pathname.startsWith('/sparklend')) {
    bgFile = '/assets/backgrounds/sparklend.svg';
  }

  return (
    <Wrapper>
      <Background $bgFile={bgFile} />
      <ContentContainer
        flexGrow={1}
        flexShrink={1}
        flexBasis={['100%', 'auto']}
        margin="0 auto"
        width="100%"
        maxWidth={['100vw', '90rem']}
        flexDirection="column"
        justifyContent="space-between"
        padding={['m l', 's m']}
        gap="m">
        <Header />

        <main>{children ? children : <Outlet />}</main>

        <Footer />
      </ContentContainer>
    </Wrapper>
  );
}
